module.exports = __webpack_public_path__ + "static/img/szty.5cc548c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/mobile/MemberCenter/assets/images/szty.jpg
// module id = 9gSQ
// module chunks = 11